import { Flex } from '../../Flex/index.js';
import { validChildren } from './constants.js';
import { VisualElementPickerStyles } from './styles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { getValidChildren } from '../../utils/validChildren.js';

const VisualElementPicker = ({
  disabled = false,
  visualElement,
  label,
  labelPair,
  size = 'md',
  ...htmlProps
}) => {
  const renderComponent = getValidChildren('VisualElementPicker', visualElement, validChildren, {
    size: 'sm'
  });
  return jsxs(VisualElementPickerStyles, {
    disabled: disabled,
    styleProps: {
      display: 'inline-flex',
      disabled
    },
    size: size,
    ...htmlProps,
    children: [renderComponent, jsxs(Flex, {
      as: "span",
      children: [jsx("span", {
        children: label
      }), labelPair && jsx("span", {
        children: labelPair
      })]
    })]
  });
};
VisualElementPicker.displayName = 'VisualElementPicker';

export { VisualElementPicker };
